<template>
  <show :selectedID="selectedId" />
</template>

<script>
import Show from "./Show.vue";

export default {
  components: {
    Show,
  },
  props: {
    selectedId: {
      type: [Number, String],
      required: true,
    },
  },
};
</script>
